import { Component, Input, OnInit } from '@angular/core';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
import { ThrowStmt } from '@angular/compiler';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { ActivatedRoute,Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { CvComponent } from '../cv/cv.component';
@Component({
  selector: 'app-format1',
  templateUrl: './format1.component.html',
  styleUrls: ['./format1.component.scss']
})
export class Format1Component implements OnInit {
  public loading = false;
  public nombre:string="";
  constructor(public authService: AuthService, private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private router: Router) {
    //console.log(localStorage.getItem("actividad_nombre"));    
   }
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  cve;
  ngOnInit() { 
    this.cve=Number(localStorage.getItem("id_persona"));
    this.get_persona(this.cve);
   
  }
  nineb_last=0;
  nineb=0;
  view_nineb_last(){
    let postData = {
      id_persona:this.cve,
      id_evaluador:0,
      a:"L"
    };
    this.authService.service("/api/nine_box_last",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                        
          this.nineb_last=res[0].nineb;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
  
  }
  view_nineb_current(){
    let postData = {
      id_persona:this.cve,
      id_evaluador:0,
      a:"C"
    };
    console.log(postData)
    this.authService.service("/api/nine_box",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          console.log(res);
          this.nineb=res[0].nineb;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
  
  }
  
  we;  
  pfpps  
  edu;
  persona={
    ingreso:"",
    nombre:"",
    apaterno:"",
    amaterno:"",
    profesion:"",
    foto:""
  };
  ver;
  version_(v){
    this.ver=v;
  }
  _competencia=[];
  _mAre1;
  _mAre2;
  exp={
    id:0,
    posicion:"",
    txdirRep1:"",
    txdirRep2:"",
    descripcion:""
  }
  get_experience(id_){
    let postData = {
      id:id_ 
    } 
      //console.log(postData);
      this.authService.service("/api/get_experience",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
              //console.log(res[0]);              
              this.exp.id=res[0].id;
              this.exp.posicion=res[0].titulo;
              this.exp.descripcion=res[0].descripcion;
              this._mAre1=res[0].idarea1;
              this._mAre2=res[0].idarea2;
              this.exp.txdirRep1=res[0].txdirRep1;
              this.exp.txdirRep2=res[0].txdirRep2;
                      
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              //swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  get_persona(cve){
    let postData = {
      id_persona:cve } 
      //console.log(postData);
      this.authService.service("/api/get_persona_id",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.persona.nombre=data[0].nombre;
            this.persona.apaterno=data[0].apaterno;
            this.persona.amaterno=data[0].amaterno;
            this.persona.profesion=data[0].profesion;
            this.persona.ingreso=data[0].ingreso.toString().substring(0,10);
            this.persona.foto=data[0].foto;
            if(this.persona.foto=="" || this.persona.foto==null){
              this.persona.foto="image-none.jpg";
            }else{
              this.persona.foto=data[0].foto;                            
            }
                           
            switch (localStorage.getItem("tprint")) {
              case "1":
                this.Pgg5();break;
              case "2":
                this.Pgg4();break;    
              default:
                break;
            }
                       
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              //swal.fire('¡API incorrecta! reportto', '', 'error');
          });     
  }
  reportto:any;
  cda;
  ls_cda(id_){
    let postData = {id:id_} 
    this.authService.service("/api/get_cda",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.cda=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  kdr;
  kpi;
  dke;
  
   toDataURL = url => fetch(url)
  .then(response => response.blob())
  .then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  }))
  img_g5;
  async Pgg5() {
    let postDatai={
      img:this.persona.foto
    }
    console.log(postDatai);
    await this.authService.service("/api/img_g4",postDatai)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);          
          console.log(res);              
          this.img_g5="data:image/jpeg;base64,"+res.img;      
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('API incorrecta!', '', 'error');
            
    });
  
    const pdf = new PdfMakeWrapper();
    pdf.pageSize('letter');
    pdf.pageOrientation("landscape");  
    pdf.pageMargins([20, 20, 20, 10]);  
     pdf.add(new Table([
      [ {text: 'Employee Profile',fillColor: '#000000', color: '#FFFFFF',borderColor: ['#000000', '#000000', '#FFFFFF', '#000000']},
        {text: 'Name:'+ this.persona.nombre +" "+ this.persona.apaterno +" "+ this.persona.amaterno ,       
          fillColor: '#000000',color: '#FFFFFF'}
      ]
    ])
    .widths([351,379]).fontSize(9).bold().alignment('left').end);  
    let postData_e={
      id:this.cve
    }
    await this.authService.service("/api/get_experience",postData_e)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
            //console.log(res[0]);              
            this.exp.id=res[0].id;
            this.exp.posicion=res[0].titulo;
            this.exp.descripcion=res[0].descripcion;
            this._mAre1=res[0].idarea1;
            this._mAre2=res[0].idarea2;
            this.exp.txdirRep1=res[0].txdirRep1;
            this.exp.txdirRep2=res[0].txdirRep2;
                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta! exp', '', 'error');
        });   
    console.log( this.exp)
    let postData_c = { 
      id_cliente:localStorage.getItem("id_cliente"),
      id_usuario:this.cve
    } 
    console.log(postData_c)
    await this.authService.service("/api/get_competencias_cliente_per",postData_c)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this._competencia=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta! gdareportto', '', 'error');
        });   
    
    
    pdf.add(new Table([
      [ {text: 'Job Title: '+this.exp.posicion,fillColor: '#000000', color: '#FFFFFF',borderColor: ['#000000', '#000000', '#FFFFFF', '#000000']},
      
      ]
    ])
    .widths([740]).fontSize(9).bold().alignment('left').end);  
    var comp=new Array();
    comp.push([ {text: 'Internal Evaluation Factors', color: '#FFFFFF',fillColor: '#000000'},{text:"", color: '#FFFFFF',fillColor: '#000000'}])
    for(var i=0;i<this._competencia.length;i++){
      comp.push([{text:this._competencia[i].competencia},{text:this._competencia[i].eval}]);
    }
    pdf.add(new Table([
      [ {image: this.img_g5,  width: 91,height:102  ,alignment:'center'  },
        
        {text: 'Date of Hire: '+this.persona.ingreso,fillColor: '#FFFFFF',color: '#000000',
          borderColor:   ['#000000', '#000000', '#000000', '#000000']},       
          new Table(
            comp
          ).widths([170,13]).layout("noBorders").end  ,
          new Table([
            [ {text: 'Ratings Scale (1-5)',fillColor: '#000000', color: '#FFFFFF'}],
            [ {text: 'Enter a value 1-5 for each of the Internal Evaluation Factors',fillColor: '#FFFFFF', color: '#000000'}],
            [ {text: '1= Still assessing',fillColor: '#FFFFFF', color: '#000000'}],
            [ {text: '2= Deficiency observed in this competence',fillColor: '#FFFFFF', color: '#000000'}],
            [ {text: '3= Additional development needed',fillColor: '#FFFFFF', color: '#000000'}],
            [ {text: '4= Proficient in this competency',fillColor: '#FFFFFF', color: '#000000'}],
            [ {text: '5= Model for this competency; could mentor others',fillColor: '#FFFFFF', color: '#000000'}],
          ]).layout("noBorders").end        
    ]
    ])
    .widths([175,165,190,182]).fontSize(9).bold().alignment('left').end);
//    this.view_nineb_current();
    this.view_nineb_last();

    let postData = {
      id_persona:this.cve,
      id_evaluador:0,
      a:"C"
    };
    await this.authService.service("/api/nine_box_last",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                        
          this.nineb_last=res[0].nineb;      
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
    let postData2 = {
      id_persona:this.cve,
      id_evaluador:0,
      a:"L"
    };
    await this.authService.service("/api/nine_box",postData2)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          console.log(res);
          this.nineb=res[0].nineb;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('API incorrecta!', '', 'error');
            this.loading=false;
        });
        pdf.add(new Table([
          [ 
            new Table([
              [ 
                new Table(
                  [
                    [
                    {text: 'Last Year Performance Rating',  fillColor: '#FFFFFF', color: '#000000', borderColor:   ['#FFFFFF', '#FFFFFF', '#000000', '#000000']},
                    {text: 'Last Year 9-Box Rating: '+this.nineb_last,fillColor: '#FFFFFF', color: '#000000',borderColor:   ['#FFFFFF', '#FFFFFF', '#000000', '#000000']},
                    {text: 'Current 9-Box Rating: '+this.nineb,fillColor: '#FFFFFF', color: '#000000',borderColor:['#FFFFFF', '#FFFFFF', '#FFFFFF', '#000000']}
                  ]
                ]
                ).widths([108,108,108]).end
                /**/
              ],
              [
                {text: 'Please provide Education and Work Experience, including dates, in the following cells'}]
            ]).widths([339]).layout("noBorders").end,
            
            {text: 'ASSESS Summary: Thinking: Factual Working: need for freedom Relating: Cultural Conformity and need to be liked.',fillColor: '#FFFFFF', color: '#000000',
              borderColor:   ['#000000', '#000000', '#000000', '#000000']},
        ]
    
        ])
        .widths([349,381]).fontSize(9).bold().alignment('left').end);  

  
    var column1 = [];

    this.ls_cda(this.cve);
    column1.push([{ text: 'EDUCATION:',fillColor: '#808080',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);

    let postDataed = {
      id_persona:this.cve,
    } 
    //console.log(postData);
    //----------------educacion---------------
    await this.authService.service("/api/get_educacion",postDataed)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.edu=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta!', '', 'error');
    });
    for(let i=0;i<this.edu.length;i++){     
      column1.push([{ text: ' * '+ this.edu[i].escuela+"/"+this.edu[i].educacion+" "+this.edu[i].anio,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
    }
    var column1_WE = [];
    column1_WE.push([{ text: 'WORK EXPERIENCE:',fillColor: '#808080',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
    //----------------experience---------------
    let postData_we = {
      id_persona:this.cve
    }
    await this.authService.service("/api/get_we",postData_we)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                 
          this.we=data;                              
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta!', '', 'error');
        });
   
    for(let i=0;i<this.we.length;i++){   
      column1_WE.push([{ text: ' * '+this.we[i].empresa+"/"+this.we[i].descripcion+" "+this.we[i].anio,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
    }    
    //console.log(column1);
    var column2 = [];
    column2.push([{ text: 'KEY STRENGTHS:',fillColor: '#808080',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
    let postData_kdr = {id:this.cve  }     
    await this.authService.service("/api/get_kdr",postData_kdr)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.kdr=data;
          },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            ///swal.fire('¡API incorrecta!', '', 'error');
    });
    for(let i=0;i<this.kdr.length;i++){   
    column2.push([{ text: ' * '+this.kdr[i].descripcion,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
    }
    var column2PE = [];
    column2PE.push([{ text: '	POSSIBLE FUTURE POSITIONS:',fillColor: '#808080',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
    let postData_pf = {
      id_persona:this.cve,
    } 
    await this.authService.service("/api/get_pfpps",postData_pf)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);  
          this.pfpps=res;
          console.log(this.pfpps);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            //swal.fire('¡API incorrecta!', '', 'error');
        });

    for(let i=0;i<this.pfpps.length;i++){ 
      if(this.pfpps[i].tipo=="F")
      column2PE.push([{ text: ' * '+this.pfpps[i].titulo,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
    }
    var column3 = [];
    
    column3.push([{ text: 'KEY DEVELOPMENT AREAS:',fillColor: '#808080',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
    let postData_kpi = {id:this.cve } 
    await this.authService.service("/api/get_kpi",postData_kpi)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.kpi=data;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            
        });
    for(let i=0;i<this.kpi.length;i++){         
        column2.push([{ text: ' * '+this.kpi[i].descripcion,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
    }
    var column3PS = [];
    column3PS.push([{ text: '	POTENTIAL SUCCESSORS:',fillColor: '#808080',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
    for(let i=0;i<this.pfpps.length;i++){ 
      if(this.pfpps[i].tipo=="S")
      column3PS.push([{ text: ' * '+this.pfpps[i].nombre+" "+this.pfpps[i].apaterno+" "+this.pfpps[i].amaterno,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
    }
   
    
    pdf.add(new Table([
      [         
        new Table(
          column1          
        ) .widths([340]).end,
        new Table(
          column2          
        ) .widths([180]).end,
        new Table(
          column3          
        ) .widths([174]).end,
      ]
    ]).widths([349,190,182]).fontSize(9).bold().alignment('left').end); 
    pdf.add(new Table([
      [         
        new Table(
          column1_WE          
        ) .widths([340]).end,
        new Table(
          column2PE          
        ) .widths([180]).end,
        new Table(
          column3PS          
        ) .widths([174]).end,
      ]
    ]).widths([349,190,182]).fontSize(9).bold().alignment('left').end); 

    pdf.create().open();  
    window.close();
    }

async Pgg4() {

        var tothoras=0;
        var totavance=0;
    
        //console.log("aqui");
    
        var contador=0;     
        const pdf = new PdfMakeWrapper();
        
        //pdf.background(  {image: this.img_g4,  width: 612,height:792    });
    
        pdf.pageSize('letter');
        pdf.pageOrientation("landscape");  
        //pdf.add(new Txt("Proyecto: ").alignment('left').color("black").bold().fontSize(10).end);  
        pdf.pageMargins([30, 40, 30, 20]);                    
            let postData = {
              id:this.cve 
            } 
              //console.log(postData);
            await this.authService.service("/api/get_experience",postData)
              .then(
                  data => {
                    var dat = JSON.stringify(data);
                    var res = JSON.parse(dat);
                      //console.log(res[0]);              
                      this.exp.id=res[0].id;
                      this.exp.posicion=res[0].titulo;
                      this.exp.descripcion=res[0].descripcion;
                      this._mAre1=res[0].idarea1;
                      this._mAre2=res[0].idarea2;
                      this.exp.txdirRep1=res[0].txdirRep1;
                      this.exp.txdirRep2=res[0].txdirRep2;
                              
                  },
                  error => {
                      var de= JSON.stringify(error);
                      var di = JSON.parse(de)
                      //swal.fire('¡API incorrecta! exp', '', 'error');
                  });   
        pdf.add(new Table([
          [ {text: 'Position title: '+ this.exp.posicion,fillColor: '#000000', color: '#FFFFFF',borderColor: ['#000000', '#000000', '#FFFFFF', '#000000']},
            {text: 'WORKING DRAFT',fillColor: '#000000',color: '#FFFFFF'}
          ]
        ])
        .widths([350,350]).fontSize(9).bold().alignment('left').end);  
    
     
        
        var column1 = [];
        column1.push([{ text: 'Job details:',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
    
        column1.push([{ text: 'Reports to: '+ this.exp.txdirRep1,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        column1.push([{ text: 'Direct reports:',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        
        this.reportto=[];
        let postData_r = {
          id_persona:this.cve } 
        await this.authService.service("/api/get_reportto",postData_r)
        .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                      
            //console.log(res);      
            this.reportto=data;
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                
            });
        console.log(this.reportto);    
        for(let i=0;i<this.reportto.length;i++){      
         column1.push([{ text: '■ '+this.reportto[i].role_card,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        }

        column1.push([{ text: 'Description: '+this.exp.descripcion,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        column1.push([{ text: 'Critical deliverables / accountabilities:',borderColor: ['#FFFFFF', '#FFFFFF', 
        '#FFFFFF','#000000']}]);
        
        this.cda=[];
        this.authService.service("/api/get_cda",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
                this.cda=data;
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)                
            });  
        for(let i=0;i<this.cda.length;i++){      
          column1.push([{ text: '■ '+this.cda[i].descripcion,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        }
        //console.log(column1);
        var column2 = [];
        column2.push([{ text: 'Key decision rights:',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
        this.kdr=[];
        await this.authService.service("/api/get_kdr",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              this.kdr=data;
              },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                ///swal.fire('¡API incorrecta!', '', 'error');
        });
        for(let i=0;i<this.kdr.length;i++){   
          column2.push([{ text: '■ '+this.kdr[i].descripcion,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        }
        column2.push([{ text: 'Key performance indicators:',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
        this.kpi=[];
        await this.authService.service("/api/get_kpi",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              this.kpi=data;
              },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                ///swal.fire('¡API incorrecta!', '', 'error');
        });
        for(let i=0;i<this.kpi.length;i++){   
          column2.push([{ text: '■ '+this.kpi[i].descripcion,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        }

        column2.push([{ text: 'Desired knowledge and experience:',borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#000000']}]);
        this.dke=[];
        await this.authService.service("/api/get_dke",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              this.dke=data;
              },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de)
                ///swal.fire('¡API incorrecta!', '', 'error');
        });
        for(let i=0;i<this.dke.length;i++){   
          column2.push([{ text: '■ '+this.dke[i].descripcion,borderColor: ['#FFFFFF', '#FFFFFF', '#FFFFFF','#FFFFFF']}]);
        }
        pdf.add(new Table([
          [         
            new Table(
              column1          
            ).end,
            new Table(
              column2
            ).end      
          ]
        ]).widths([350,350]).fontSize(9).bold().alignment('left').end);  
        pdf.create().open();  
        window.close();
          }
    

          
          }
